import { Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { apiURL } from 'src/consumer/services'
import { getData, getDataWithParams } from 'src/consumer/services/profileService'
import footerImage from './footerImage.png'
import { toast } from 'react-toastify'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
const ChangePassword = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('signup')

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPass] = useState('')
  const [isLoading, setLoading] = useState()
  const [page, setPage] = useState('unset') // success, error, unset

  async function handleParameter() {
    if (token) {
      const response = await getData(`/api/user/account/recover/${token}`)
      if (response?.status === 200) {
      } else {
        setPage('error')
      }
    } else {
      setPage('error')
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    const response = await getDataWithParams(`/api/user/password/change-with-code`, {
      token: token,
      newPassword: password,
    })
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      setPage('success')
    } else {
      setPage('error')
    }
    setLoading(false)
  }

  useEffect(() => {
    handleParameter()
  }, [])

  return (
    <>
      <PublicAppHeader
        config={{ showLinks: false }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
        showLinks={false}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
        preferredLoginInputType={'email'} // mobile, email
      />

      {page === 'error' && (
        <div style={{ width: 'fit-content', margin: '80px auto' }}>
          <div style={{ fontSize: '20px', fontWeight: '500' }}>
            Oops! That&apos;s an invalid link.
          </div>
          <div>
            Let us take you home.{' '}
            <span onClick={() => navigate('/')}>
              <u>Click here</u>
            </span>
          </div>
        </div>
      )}

      {page === 'success' && (
        <div style={{ width: 'fit-content', margin: '80px auto' }}>
          <div style={{ fontSize: '20px', fontWeight: '500', color: 'green' }}>
            Password Changed Successfully!
          </div>
          <div>
            <span
              onClick={() => {
                setTypeOfClubbedAuthModal('login')
                setShowClubbedAuthModal(true)
              }}
            >
              <u>Click here to login</u>
            </span>
          </div>
        </div>
      )}

      {page === 'unset' && (
        <>
          <div
            style={{
              margin: '64px 0 24px',
              fontSize: '24px',
              fontWeight: '500',
              textAlign: 'center',
            }}
          >
            Create a New Password
          </div>
          <div style={{ width: '350px', margin: 'auto' }}>
            <form onSubmit={handleSubmit} className="w-full">
              <div className="w-100">
                <i>Enter a New Password (min 6 digits)</i>
              </div>
              <input
                className="w-100"
                placeholder="Password"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                style={{ border: '1px solid #cecece', borderRadius: '4px', padding: '8px' }}
              />
              <div className="w-100" style={{ marginTop: '16px' }}>
                <i>Please confirm your password</i>
              </div>
              <input
                className="w-100"
                placeholder="Confirm Password"
                type="password"
                onChange={(e) => setConfirmPass(e.target.value)}
                style={{ border: '1px solid #cecece', borderRadius: '4px', padding: '8px' }}
              />
              {password && confirmPassword && password === confirmPassword && password.length >= 6 && (
                <div
                  style={{ cursor: 'pointer', fontSize: '12px', textAlign: 'right' }}
                  onClick={() => {
                    navigator.clipboard.writeText(password)
                    toast.info('Password copied to clipboard')
                  }}
                >
                  <u>Copy</u>
                </div>
              )}
              {password && confirmPassword && password.length >= 6 && (
                <div
                  style={{
                    marginTop: '8px',
                    color: password === confirmPassword ? 'green' : 'red',
                  }}
                >
                  {password === confirmPassword
                    ? 'Looks good!'
                    : 'Please enter the same password as above'}
                </div>
              )}
              <Button
                disabled={!(password && confirmPassword && password.length >= 6)}
                variant="contained"
                sx={{
                  margin: '16px auto',
                }}
                type="submit"
              >
                {'Continue '}
                {isLoading && <Spinner animation="border" variant="light" size="sm" />}
              </Button>
            </form>
          </div>
        </>
      )}
    </>
  )
}

export default ChangePassword
